import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserService } from './common/service/user.service';
import { TranslatePipe } from '@ngx-translate/core';
import { Role } from './core/auth/role.enum';
import { UserPreferenceService } from './common/service/user-preference.service';

@Component({
  selector: 'gate-root',
  standalone: true,
  imports: [RouterOutlet, TranslatePipe],
  template: `
    @if (isImpersonationBootstrapInProgress()) {
      <div class="impersonation-bootstrap-overlay">
        <i class="pi pi-spin pi-spinner"></i>
        <p>{{(isACPUser ? 'impersonationInProgressMsg' : 'pleaseWaitMsg') | translate}}</p>
      </div>
    }@else {
      <router-outlet></router-outlet>
    }
    
  `,
})
export class AppComponent{
  private userService = inject(UserService);
  private userPreferenceService = inject(UserPreferenceService);
  public isACPUser = this.userService.currentUser().roles.includes(Role.AccountManager);
  public isImpersonationBootstrapInProgress = this.userService.isImpersonationBootstrapInProgress;

  constructor() {
    this.userPreferenceService.initialize();
  }
}
